import nfetch from '@/utils/events/nfetch'

import PDFService from './PDFService'

export default class EtiquetaTransportadoraPDFService extends PDFService {
  constructor() {
    super('EtiquetaTransportadoraPDF')
  }

  public getListEtiquetasByVendaIds(vendaIds: number[]): Promise<Response> {
    return nfetch(`/${this.controllerName}/GeraPDFBatchByVendas`, {
      method: 'post',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
      body: JSON.stringify(vendaIds),
    })
  }
}
